import theme from 'config/theme';

export default {
  wrapper: {
    display: 'flex',
    gap: '16px',
    flexDirection: 'column',
  },
  vehicleTitle: {
    color: theme.palette.grays.gray700,
    fontWeight: 700,
    fontSize: '1.125rem',
  },
  image: {
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    width: '230px',
    height: '130px',
    backgroundSize: 'contain',
    margin: '0 auto',
  },
  plate: {
    fontWeight: 500,
    color: theme.palette.grays.gray500,
  },

  row: {
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
  },
  rowTitle: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.palette.grays.gray500,
  },
  rowValue: {
    fontWeight: 500,
    color: theme.palette.grays.gray700,
    a: {
      textDecoration: 'none',
      fontWeight: 500,
      color: theme.palette.blues.primaryBlue500,
    },
  },
  title: {
    fontWeight: 700,
    color: theme.palette.grays.gray700,
  },
  chips: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
  },
  chip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '28px',
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.palette.blues.babyBlue900,
    background: theme.palette.blues.babyBlue200,
    padding: '12px',
    borderRadius: '20px',
  },
  shortName: {
    width: '24px',
    height: '24px',
    fontSize: '12px',
  },
  textfield: {
    width: '100%',
    height: '100%',
    fontSize: '0.875rem',

    '& .MuiSelect-nativeInput': {
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '10px 12px',
      fontSize: '0.875rem',
      color: theme.palette.grays.gray600,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: `none`,
    },

    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.blues.lightestBlue,
      '&:hover': {
        backgroundColor: theme.palette.blues.lightestBlue,

        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 0,
          border: 'none',
        },
      },
    },
  },
  rowSpace: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};
